/**
 * En-tete d'un module plein ecran (Evenements, Paniers, leurs facettes
 * producteur) : retour a gauche, titre au centre, pastilles a droite.
 *
 * POURQUOI CE COMPOSANT EXISTE (S58)
 * ----------------------------------
 * Les quatre modules recopiaient le meme `<header className="... px-4 pt-4">`.
 * Recopie a l'identique, **defaut recopie a l'identique** : `pt-4` est un
 * padding FIXE de 16 px, qui ignore la zone de securite iOS. Sur un iPhone a
 * encoche, la pastille de retour et celle de casquette passaient donc SOUS
 * l'heure, la 4G et la batterie — illisibles et difficiles a toucher (remonte
 * par Enzo, captures du 1er septembre). Le hub, lui, n'avait pas le probleme :
 * `HubHeader` gere `env(safe-area-inset-top)` depuis toujours.
 *
 * La regle ne tient pas si chaque module doit y penser. Elle est donc PORTEE
 * PAR LE CADRE : tout ce qui est commun (gouttiere `px-4`, retrait haut, hauteur
 * de ligne, gouttiere entre elements) vit ici ; les modules ne fournissent que
 * ce qui leur est propre. Un nouveau module ne peut plus oublier la marge.
 *
 * Regle ecrite : `docs/DESIGN-GUIDE.md` §11.8.
 */

/**
 * @param {{label: string, onClick: () => void}} retour  Pastille de gauche.
 * @param {React.ReactNode} titre    Emoji + nom (ex. « 🎪 Évènements »).
 * @param {React.ReactNode} sousTitre Ligne secondaire sous le titre (S65) —
 *   sert a nommer l'evenement ou l'on se trouve (« ⛺ Marché · sam. 14 juin ») ;
 *   optionnelle : les modules qui n'en passent pas gardent l'en-tete d'avant.
 * @param {React.ReactNode} children Pastilles de droite (wallet, casquette...).
 */
export default function EnteteModule({ retour, titre, sousTitre, children }) {
  return (
    <header
      className="flex items-center gap-2.5 px-4 pb-3"
      // MEME calcul que HubHeader : le retrait du hub et celui d'un module sont
      // identiques, donc la pastille de retour ne bouge pas d'un pixel quand on
      // passe de l'un a l'autre (decalage remonte par Enzo en S33, corrige en
      // S36 sur la gouttiere, ici sur le retrait haut).
      style={{ paddingTop: 'max(1.1rem, calc(env(safe-area-inset-top) + 0.5rem))' }}
    >
      {retour && (
        <button
          onClick={retour.onClick}
          className="panneau-verre text-ink flex items-center gap-1 rounded-full px-3 py-2 text-[12.5px] font-bold flex-shrink-0"
        >
          ← <span className="font-serif">{retour.label}</span>
        </button>
      )}
      <div className="flex-1 min-w-0">
        <p className="font-serif text-[19px] truncate text-ink leading-tight">{titre}</p>
        {sousTitre && <p className="text-[11.5px] font-semibold truncate text-ink/55 mt-0.5">{sousTitre}</p>}
      </div>
      {children}
    </header>
  )
}
